import React from "react";

const StepThree = () => {
  return (
    <div>
      <h1>Step 3</h1>
    </div>
  );
};

export default StepThree;
